import React from "react";
import {
  Button,
  Container,
  Typography,
  Box,
  styled,
  keyframes,
} from "@mui/material";
import "animate.css";

// Keyframes for logo pulse animation
const pulseAnimation = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.7); }
  100% { transform: scale(1); }
`;

// Styled component for the hero section
const HeroBox = styled(Box)(({ theme }) => ({
  position: "relative",
  overflow: "hidden",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: theme.spacing(10, 0),
  textAlign: "center",
  color: theme.palette.common.white,
  backgroundImage: `url('/images/bg-hair-style.jpg')`,
  backgroundSize: "cover",
  backgroundPosition: "center",

  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    backdropFilter: "blur(4px)",
    zIndex: 1,
  },

  "& > *": {
    position: "relative",
    zIndex: 2,
  },
}));

// Video Box styling
const VideoBox = styled("video")(({ theme }) => ({
  width: "100%",
  height: "auto",
  borderRadius: theme.shape.borderRadius,
  boxShadow: "0 0 15px rgba(0,0,0,0.5)",
  [theme.breakpoints.down("sm")]: {
    marginBottom: theme.spacing(2),
  },
}));

const StyledButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

// Contact Box to show info on the Header
const ContactBox = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: theme.spacing(2),
  right: theme.spacing(2),
  backgroundColor: "rgba(255, 255, 255, 0.1)",
  color: "#fff",
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(2),
  zIndex: 3,
  textAlign: "right",
  lineHeight: 1.5,
  fontSize: "0.875rem",
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.3)",
  backdropFilter: "blur(5px)",
  maxWidth: 300,

  // Responsive fixes
  [theme.breakpoints.down("sm")]: {
    position: "relative",
    top: 0,
    right: 0,
    marginBottom: theme.spacing(2),
    textAlign: "center",
    width: "100%",
    maxWidth: "100%",
    fontSize: "0.8rem",
    padding: theme.spacing(1.5),
  },
}));

const Header = () => {
  return (
    <HeroBox>
      {/* Contact info floating box */}
      <ContactBox className="animate__animated animate__fadeInRight">
        <strong>PTH Saloon</strong>
        {/* <br />
        12990 National Rd SW, Pataskala, OH
        <br />
        8515 Refugee Rd, Pickerington, OH */}
        <br />
        859 Windmiller Dr, Pickerington, OH
        <br />
        📞 +1 (614) 490-7698
        <br />
        📞 +1 (281) 948-8761
        <br />
        📧{" "}
        <a
          href="mailto:tilaadhikari7@gmail.com"
          style={{ color: "#fff", textDecoration: "underline" }}
        >
          tilaadhikari7@gmail.com
        </a>
      </ContactBox>

      {/* Main content */}
      <Container maxWidth="md">
        <Typography
          className="animate__animated animate__bounceInLeft"
          variant="h5"
          component="p"
          gutterBottom
          color="white"
        >
          Experience the best beauty and wellness services
        </Typography>
        <StyledButton
          className="animate__animated animate__heartBeat"
          variant="contained"
          color="primary"
          size="large"
          href="/book-appointment"
        >
          <Box
            component="img"
            src="/images/logo-no-bg.png"
            alt="Logo"
            sx={{
              height: 25,
              marginRight: 1,
              animation: `${pulseAnimation} 2s infinite ease-in-out`,
            }}
          />
          Book!
        </StyledButton>
      </Container>
    </HeroBox>
  );
};

export default Header;
